import { parse } from 'cookie';

/**
 * Retrieves the Atlassian analytics anonymous ID from the browser cookie; returns empty string if not found.
 */
export const getAnalyticsAnonymousId = (): string => {
  return (
    decodeURIComponent(parse(document?.cookie)?.ajs_anonymous_id || '').replace(
      /['"]+/g,
      '',
    ) || ''
  );
};
